<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.$store.dispatch('customers/getCustomers')
  }
}
</script>

<style>
html, body {
  padding: 0;
  margin: 0;
}
.mrg-20 {
  padding-bottom: 20px;
}
.mrg-40 {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue